module.exports = __webpack_public_path__ + "img/empty.db57f50e.svg";